export class ServiceResponse {
  public success = true
  public data: any = null
  public messages: Array<string> | string = ''
}
